import { ApiServiceBase, DEFAULT_API_OPTIONS } from "./apiServiceBase";

export class OrderService extends ApiServiceBase {
  constructor({ baseUrl, timeout } = DEFAULT_API_OPTIONS) {
    super({ baseUrl, timeout });
    this._path = "Order";
  }

  paymentCheck(meterNo) {
    return this._axios.get(`${this._path}/PaymentCheck/${meterNo}`);
  }

  add(meterNo, quantity) {
    return this._axios.post(`${this._path}/Add/${meterNo}?quantity=${quantity}`);
  }

  getPayChannel(meterNo) {
    return this._axios.get(`${this._path}/GetPayChannel/${meterNo}`);
  }

  getPayOrder(orderNo) {
    return this._axios.get(`${this._path}/GetPayOrder/${orderNo}`);
  }
}

export const orderService = new OrderService();
